import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

const terms = [
    {
        id: 'anti-counterfeit',
        term: 'Anti-Counterfeit QR Code',
        definition: "An anti-counterfeit QR code is designed to resist duplication, unlike a standard QR code which is just a container for data that anyone can photograph and reprint. QRmor is built specifically as an anti-counterfeit QR code — when a copy of it is scanned, the system recognizes it as a duplicate rather than validating it as genuine."
    },
    {
        id: 'non-clonable',
        term: 'Non-Clonable',
        definition: "A non-clonable code is one that cannot be successfully reproduced, even with a high-resolution photograph or scan of the original. QRmor's non-clonable technology is the core of how it differs from an ordinary QR or barcode: the code itself is engineered so that a cloned version fails verification the moment it's checked."
    },
    {
        id: 'secured-qr-code',
        term: 'Secured QR Code',
        definition: "A secured QR code adds a verification layer on top of the basic scan-and-link function most QR codes offer. Instead of simply opening a webpage, a secured QR code like QRmor checks the authenticity of the code itself before confirming a genuine result — turning a simple scan into a trust check."
    },
    {
        id: 'clone-detection',
        term: 'Clone Detection',
        definition: "Clone detection refers to a system's ability to identify when a duplicated or copied code is being scanned, rather than the original. QRmor's clone detection works in real time — a flagged scan is logged immediately with its time and location, so a business can see exactly where counterfeit activity is surfacing."
    },
    {
        id: 'track-and-trace',
        term: 'Track and Trace',
        definition: "Track and trace describes the ability to follow a product's authenticity checks across its supply chain — from manufacturing through to the point a customer scans it. This is increasingly a regulatory requirement, not just a nice-to-have: India's Schedule H2 mandate, for example, requires track and trace for vaccines, antimicrobials, anti-cancer medicines, and narcotic and psychotropic drugs."
    },
    {
        id: 'brand-protection',
        term: 'Brand Protection',
        definition: "Brand protection covers the tools and processes a company uses to prevent counterfeit or unauthorized versions of its products from damaging customer trust and revenue. QR-based brand protection, like QRmor, gives both the company and the end customer a fast way to confirm a product is genuine, without special hardware or an app."
    },
    {
        id: 'sku-wise-licensing',
        term: 'SKU-Wise Licensing',
        definition: "SKU-wise licensing means a business can activate anti-counterfeit protection for individual product lines (SKUs) rather than committing to protect an entire catalog at once. This lets a company start with its highest-risk products and expand coverage as needed."
    }
];

export default function Glossary() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'Anti-Counterfeit & Non-Clonable QR Code Glossary | QRmor';
        const metaDesc = document.querySelector('meta[name="description"]');
        const content = 'Key terms in anti-counterfeit and non-clonable QR technology, explained: clone detection, secured QR codes, track and trace, brand protection, and SKU-wise licensing.';
        if (metaDesc) {
            metaDesc.setAttribute('content', content);
        } else {
            const tag = document.createElement('meta');
            tag.name = 'description';
            tag.content = content;
            document.head.appendChild(tag);
        }
    }, []);

    return (
        <>
            <header>
                <nav className="wrap">
                    <div className="brand">
                        <img src="/assets/QRmor.png" alt="QRmor logo" />
                    </div>
                    <Link to="/" className="btn btn-primary btn-sm">Back to home</Link>
                </nav>
            </header>

            <section>
                <div className="wrap legal-content" style={{ maxWidth: 860, padding: '48px 32px 80px' }}>
                    <span className="eyebrow">Glossary</span>
                    <h1 style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginTop: 12, marginBottom: 20 }}>
                        Anti-Counterfeit & Non-Clonable QR Code Terms, Explained
                    </h1>
                    <p style={{ color: 'var(--ink-soft)', fontSize: 16, lineHeight: 1.7, marginBottom: 32 }}>
                        Anti-counterfeit technology comes with its own vocabulary. Here's what the key terms
                        actually mean — and how QRmor's non-clonable QR code approach fits into each one.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
                        {terms.map(t => (
                            <div key={t.id} id={t.id}>
                                <h3>{t.term}</h3>
                                <p style={{ color: 'var(--ink-soft)', marginTop: 8, lineHeight: 1.7 }}>
                                    {t.definition}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div style={{ marginTop: 40 }}>
                        <Link to="/technology" className="btn btn-primary" style={{ marginRight: 12 }}>See the technology</Link>
                        <a href="/#contact" className="btn btn-primary">Request a demo</a>
                    </div>
                </div>
            </section>
        </>
    );
}